import { render, staticRenderFns } from "./PurcDailyRpt.vue?vue&type=template&id=b597620e&scoped=true&"
import script from "./PurcDailyRpt.vue?vue&type=script&lang=js&"
export * from "./PurcDailyRpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b597620e",
  null
  
)

export default component.exports